const getters = {
  userInfo: state => state.app.userInfo,
  title: state => state.app.title,
  schoolName: state => state.app.schoolName,
  schoolIps: state => state.app.schoolIps,
  schoolsArray: state => state.app.schoolsArray,
  header: state => state.app.header,
  visitorInfo: state => state.app.visitorInfo,
  visitorSchoolIps: state => state.app.visitorSchoolIps,

  // 点播
  videoKeyword: state => state.video.keyword,
  currentVideo: state => state.video.currentVideo,

  // 巡课
  currentCourse: state => state.tourCourse.currentCourse,
  courseKeyword: state => state.tourCourse.keyword,

  // 直播
  currentLive: state => state.live.currentLive,
  liveKeyword: state => state.live.keyword
};
export default getters;
